import Whitelist from './whitelist'

const modules = {
    Whitelist
}

const state = {}

const mutations = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    modules
}
